import { useState, useEffect, useRef } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import api from '~/api'
import { selectProducts } from '~/selectors'

export default function useEcommerce() {
  const mounted = useRef(false)

  const [openEcommerce, setOpenEcommerce] = useState(null)
  const [apiEcommerce, setApiEcommerce] = useState(null)
  const [dataEcommerce, setDataEcommerce] = useState(null)
  const [loadingEcommerce, setLoadingEcommerce] = useState(false)

  const { products, config } = useSelector(selectProducts, shallowEqual)
  const { limitViews = false, checkStoreAddManually = false, checkStoreFeatured = false } = config

  useEffect(() => {
    mounted.current = true
    return () => (mounted.current = false)
  }, [])

  useEffect(() => {
    async function fetch() {
      if (limitViews && checkStoreAddManually && !checkStoreFeatured) return

      setLoadingEcommerce(true)
      let gtins

      if (openEcommerce === 'all') {
        gtins = products
          ?.map((i) => i.gtin)
          .slice(0, 5)
          .join()
      } else {
        gtins = openEcommerce.gtin
      }

      try {
        const { group, ...rest } =
          apiEcommerce.name === 'intellibrand'
            ? await api.ecommerce(gtins)
            : await api.ecommerceGoogle(gtins, apiEcommerce.location)

        rest?.single
          ? mounted.current && setDataEcommerce(rest)
          : mounted.current && setDataEcommerce(group)
      } catch (err) {
        console.log(err)
      }

      setTimeout(() => {
        setLoadingEcommerce(false)
      }, 1500)
    }

    openEcommerce ? fetch() : setDataEcommerce(null)
  }, [openEcommerce])

  return { openEcommerce, setOpenEcommerce, dataEcommerce, loadingEcommerce, setApiEcommerce }
}
